// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".worker-detail[data-v-1e97e39d]{padding:24px}.box-container .content[data-v-1e97e39d]{display:flex;flex-direction:row}.box-container .content .photo-block[data-v-1e97e39d]{height:161px;min-width:161px;margin-right:24px}.card-container[data-v-1e97e39d]{margin-top:24px}", ""]);
// Exports
module.exports = exports;
